import React, { Component } from 'react';

import { Grid } from "@mui/material";

import Modal from "../../../src/component/modal/ModalTemplate";
import TextInput from "../input/TextInput";
import Loading from "../loading/Loading";

import * as apiUtil from "../../util/apiUtil";
import SingleButton from "../button/SingleButton";
import SwitchButton from "../button/SwitchButton";
import * as stringUtil from "../../util/stringUtil";
import DateInput from "../input/DateInput";
import * as dateUtil from "../../util/dateUtil";

class MessageAIModal extends Component {
    constructor(props) {
        super(props);

        this.refInitValue = this.refInitValue.bind(this);

        this.setLoading = this.setLoading.bind(this);
        this.handleType = this.handleType.bind(this);
        this.setValue = this.setValue.bind(this);
        this.ajaxGenerateAIMessage = this.ajaxGenerateAIMessage.bind(this);
        this.ajaxCheckAIMessage = this.ajaxCheckAIMessage.bind(this);
        this.applyGeneratedMessage = this.applyGeneratedMessage.bind(this);

        this.highlightStr = this.highlightStr.bind(this);

        this.state = {
            loading: false,
            type: 'GENERATE',

            brandName: '',
            eventContent: '',
            eventFrom: dateUtil.dateToStr(new Date()),
            eventTo: dateUtil.dateToStr(new Date()),
            eventUrl: 'https://',
            eventWarning: '',
            customerCenter: '',

            inputTitle: '',
            inputBody: '',
            viewDelta: 'N',

            resultTitle: '',
            resultBody: '',
            checkResultTitle: '',
            checkResultBody: '',
            deltaTitle: '수정된 제목이 표시됩니다.',
            deltaBody: '수정된 본문이 표시됩니다.',
        }
    }

/*
[솔라피]
안녕하세요?

요청하신 080 수신거부가 정상적으로 처리 되었습니다.
차단된 발신번호는 아래와 같으며,

- 차단일시: 2023년 12월 28일 09시 35분
- 차단된 발신번호: 0212345678

차단해제를 원하실 경우 아래 링크에서 하실 수 있습니다.

감사합니다.

[수신거부목록 보기]
[모바일]: https://console.solapi.com/unsubscribe
 */

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.state.type !== nextState.type
            || this.state.viewDelta !== nextState.viewDelta
            || this.props.isOpen !== nextState.isOpen
        )
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    refInitValue() {
        const { checkResultTitle, checkResultBody } = this.state;

        this.setState({
            inputTitle: checkResultTitle,
            inputBody: checkResultBody,
            // checkResultTitle: '',
            // checkResultBody: '',
            viewDelta: 'N',
        })
    }

    handleType(type) {
        this.setState({ type: type });

        if (type === 'CHECK') {
            const { resultTitle, resultBody } = this.state;

            if (resultTitle || resultBody) {
                this.setState({
                    checkResultTitle: '',
                    checkResultBody: '',
                    inputTitle: resultTitle,
                    inputBody: resultBody,
                });
            }
        }
    }

    setValue(id, value) {
        const { viewDelta } = this.state;

        switch (id) {
            case 'brandName':
                this.setState({ brandName: value });
                break;
            case 'eventContent':
                this.setState({ eventContent: value });
                break;
            case 'eventFrom':
                this.setState({ eventFrom: value });
                break;
            case 'eventTo':
                this.setState({ eventTo: value });
                break;
            case 'eventUrl':
                this.setState({ eventUrl: value });
                break;
            case 'eventWarning':
                this.setState({ eventWarning: value });
                break;
            case 'customerCenter':
                this.setState({ customerCenter: value });
                break;
            case 'inputTitle':
                this.setState({ inputTitle: value });
                break;
            case 'inputBody':
                this.setState({ inputBody: value });
                break;
            case 'viewDelta':
                this.setState({ viewDelta: viewDelta === "Y" ? "N" : "Y" });
                break;
        }
    }

    ajaxGenerateAIMessage() {
        const { brandName, eventContent, eventFrom, eventTo, eventUrl, eventWarning, customerCenter } = this.state;

        if (! brandName && ! eventContent && ! eventFrom && ! eventTo && ! eventUrl && ! eventWarning && ! customerCenter) {
            alert("입력값을 확인해 주세요.")
            return;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/ai/generate",
            method: apiUtil.requestMethod.POST,
            data: {
                brandName: brandName ? "브랜드명:" + brandName : null,
                eventContent: eventContent ? "이벤트 내용:" + eventContent : null,
                eventPeriod: (eventFrom && eventTo) ? "이벤트 기간: " + eventFrom + " ~ " + eventTo : null,
                eventUrl: eventUrl ? "이벤트 URL:" + eventUrl : null,
                eventWarning: eventWarning ? "이벤트 유의사항:" + eventWarning : null,
                customerCenter: customerCenter ? "고객센터:" + customerCenter : null,
            },
            success: async (result) => {
                this.setState({
                    resultTitle: result.title,
                    resultBody: result.body,
                });
            }
        })
    }

    ajaxCheckAIMessage() {
        const { inputTitle, inputBody, viewDelta } = this.state;

        if (! inputTitle && ! inputBody) {
            alert("입력값을 확인해 주세요.")
            return;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/ai/check",
            method: apiUtil.requestMethod.POST,
            data: {
                inputTitle: inputTitle,
                inputBody: inputBody,
                viewDelta: viewDelta,
            },
            success: async (result) => {
                this.setState({
                    deltaTitle: this.highlightStr(result.deltaTitle),
                    deltaBody: this.highlightStr(result.deltaBody),
                    checkResultTitle: result.title,
                    checkResultBody: result.body,
                });
            }
        })
    }

    applyGeneratedMessage() {
        const { type, resultTitle, resultBody, checkResultTitle, checkResultBody } = this.state;
        const { setMessage } = this.props;

        if (type === 'GENERATE') {
            setMessage(resultTitle, resultBody);
        } else if (type === 'CHECK') {
            setMessage(checkResultTitle, checkResultBody);
        }
    }

    highlightStr(str) {
        return str.replace(/\{\{((.|\n)*?)\}\}/g, (_, variable) => {
            let firstIndex = variable.charAt(0);

            if (firstIndex === '+') {
                return `<span class="fw-bolder text-primary">{{${variable}}}</span>`;
            } else if (firstIndex === '-') {
                return `<span class="fw-bolder text-danger">{{${variable}}}</span>`;
            } else {
                return `<span class="fw-bolder text-success">{{${variable}}}</span>`;
            }
        });
    }

    render() {
        const { loading } = this.state;
        const { isOpen, handleClose } = this.props;

        const { type } = this.state;
        const { handleType } = this;

        const {
            brandName, eventContent, eventFrom, eventTo, eventUrl, eventWarning, customerCenter,
            inputTitle, inputBody, viewDelta, checkResultTitle, checkResultBody,
            resultTitle, resultBody, deltaTitle, deltaBody
        } = this.state;
        const { setValue, ajaxGenerateAIMessage, ajaxCheckAIMessage, applyGeneratedMessage } = this;

        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                className={"react-full-modal"}
                modalTitle={"AI 문구 검수/생성"}
                overlayClassName="modal-overlay"
            >
                <Loading loading={loading}/>
                <div className='modal-body p-0 overflow-y-auto'>
                    <div className="d-flex p-4 pb-0">
                        <div className="form-check pe-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="generate"
                                id="generate"
                                value="GENERATE"
                                onChange={() => handleType("GENERATE")}
                                checked={type === "GENERATE"}
                            />
                            <label className="form-check-label" htmlFor="generate">
                                생성
                            </label>
                        </div>
                        <div className="form-check pe-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="check"
                                id="check"
                                value="CHECK"
                                onChange={() => handleType("CHECK")}
                                checked={type === "CHECK"}
                            />
                            <label className="form-check-label" htmlFor="check">
                                검토
                            </label>
                        </div>
                    </div>
                    {
                        type === 'GENERATE' &&
                        <>
                            <ul className="mb-0 pb-0">
                                <li className="p-0 text-light-gray h6">- 입력해 주신 가이드라인에 맞춰 문구 생성을 진행합니다.</li>
                                <li className="p-0 text-light-gray h6">- AI가 유추할 수 없는 단어를 사용할 경우, 정상적인 문구 생성이 불가합니다.</li>
                                <li className="p-0 mb-0 text-light-gray h6">- 해당 기능을 통해 생성된 문구여도, SKT측 검수는 필요합니다. (평균 2~3일 소요)</li>
                            </ul>
                            <Grid container spacing={0} colums={12}>
                                <Grid item md={6} xs={6} className="p-4">
                                    <h5 className="mb-1 mt">브랜드명</h5>
                                    <TextInput
                                        className="form-control mb-4"
                                        type="text"
                                        id="brandName"
                                        placeholder="메시지 발송을 진행할 브랜드 명을 입력해 주세요. (ex, 비즈팅)"
                                        value={brandName}
                                        onChange={setValue}
                                    />
                                    <h5>이벤트 내용</h5>
                                    <TextInput
                                        className="form-control mb-4"
                                        type="text"
                                        id="eventContent"
                                        rows={2}
                                        placeholder="메시지 발송을 진행할 이벤트 내용을 입력해 주세요.&#13;&#10;(ex, 비즈팅 신규가입 이벤트 안내, 비즈팅에서 신규 가입하신 고객님들을 대상으로 무료쿠폰을 드립니다.)"
                                        value={eventContent}
                                        onChange={setValue}
                                    />
                                    <h5>이벤트 기간</h5>
                                    <div className="d-flex">
                                        <DateInput
                                            className="form-control mb-4"
                                            id="eventFrom"
                                            value={eventFrom}
                                            onChange={setValue}
                                        />
                                        <span>~</span>
                                        <DateInput
                                            className="form-control mb-4"
                                            id="eventTo"
                                            value={eventTo}
                                            onChange={setValue}
                                        />

                                    </div>
                                    <h5>이벤트 URL</h5>
                                    <TextInput
                                        className="form-control mb-4"
                                        type="text"
                                        id="eventUrl"
                                        placeholder="이벤트 내용을 확인할 수 있는 URL을 입력해 주세요."
                                        value={eventUrl}
                                        onChange={setValue}
                                    />
                                    <h5>이벤트 유의사항</h5>
                                    <TextInput
                                        className="form-control mb-4"
                                        type="text"
                                        id="eventWarning"
                                        rows={2}
                                        placeholder="메시지 발송을 진행할 이벤트 내용을 입력해 주세요.&#13;&#10;(ex, 비즈팅 신규가입 이벤트 안내, 비즈팅에서 신규 가입하신 고객님들을 대상으로 무료쿠폰을 드립니다.)"
                                        value={eventWarning}
                                        onChange={setValue}
                                    />
                                    <h5>고객센터</h5>
                                    <TextInput
                                        className="form-control mb-4"
                                        type="text"
                                        id="customerCenter"
                                        placeholder="연락 가능한 고객센터 정보를 입력해 주세요. (ex, 비즈팅 고객센터 1688-3764)"
                                        value={customerCenter}
                                        onChange={setValue}
                                    />
                                    <div className='modal-footer'>
                                        <SingleButton
                                            className="btn btn-secondary me-2"
                                            label="닫기"
                                            handleClick={handleClose}
                                        />
                                        <SingleButton
                                            className="btn btn-primary"
                                            label="생성하기"
                                            handleClick={ajaxGenerateAIMessage}
                                        />
                                    </div>
                                </Grid>
                                <Grid item md={6} xs={6} className="p-4">
                                    <h5>생성 결과</h5>
                                    <TextInput
                                        className="form-control mb-4"
                                        type="text"
                                        id="resultTitle"
                                        placeholder="작성된 제목이 표시됩니다."
                                        value={resultTitle}
                                        readOnly={true}
                                    />
                                    <TextInput
                                        className="form-control mb-4"
                                        type="text"
                                        id="resultBody"
                                        rows={20}
                                        placeholder="작성된 본문이 표시됩니다."
                                        value={resultBody}
                                        readOnly={true}
                                    />
                                    <div className='modal-footer'>
                                        <SingleButton
                                            className="btn btn-primary"
                                            label="적용하기"
                                            handleClick={applyGeneratedMessage}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </>
                    }
                    {
                        type === 'CHECK' &&
                        <>
                            <ul className="mb-0 pb-0">
                                <li className="p-0 text-light-gray h6">- 입력해 주신 문구에 대한 문구 검토를 진행합니다.</li>
                                <li className="p-0 text-light-gray h6">- SKT 정책에 기반하여 검토하므로, 많은 문구 수정이 있을 수 있습니다.</li>
                                <li className="p-0 text-light-gray h6">- URL은 반드시 https://로 시작해야 합니다. 그렇지 않을 경우, URL 반응률이 정상적으로 분석되지 않아 통계 제공이 불가한 점 참고 부탁드립니다.</li>
                                <li className="p-0 mb-0 text-light-gray h6">- 해당 기능을 통해 생성된 문구여도, SKT측 검수는 필요합니다. (평균 2~3일 소요)</li>
                            </ul>
                            <Grid container spacing={0} colums={12}>
                                <Grid item md={6} xs={6} className="p-4">
                                    <h5>메시지 초안</h5>
                                    <TextInput
                                        className="form-control mb-4"
                                        type="text"
                                        id="inputTitle"
                                        placeholder="메시지 제목을 입력하세요."
                                        value={inputTitle}
                                        onChange={setValue}
                                    />
                                    <TextInput
                                        className="form-control mb-4"
                                        type="text"
                                        id="inputBody"
                                        rows={20}
                                        placeholder="메시지 내용을 입력하세요."
                                        value={inputBody}
                                        onChange={setValue}
                                    />
                                    <div className='modal-footer'>
                                        <SingleButton
                                            className="btn btn-secondary me-2"
                                            label="닫기"
                                            handleClick={handleClose}
                                        />
                                        <SingleButton
                                            className="btn btn-primary"
                                            label="검수하기"
                                            handleClick={ajaxCheckAIMessage}
                                        />
                                    </div>
                                </Grid>
                                <Grid item md={6} xs={6} className="p-4">
                                    <h5>메시지 수정안</h5>
                                    {
                                        viewDelta === 'Y' ?
                                            <>
                                                <div
                                                    className="form-control mb-4"
                                                    // contentEditable={false}
                                                    aria-placeholder="수정된 제목이 표시됩니다."
                                                    style={{ height: 31, maxHeight: 31, fontSize: 14 }}
                                                    dangerouslySetInnerHTML={{ __html: stringUtil.convertNewlineToBr(deltaTitle) }}>
                                                </div>
                                                <div
                                                    className="form-control mb-4"
                                                    // contentEditable={false}
                                                    style={{ height: 442, maxHeight: 442, overflow: "auto", fontSize: 14 }}
                                                    dangerouslySetInnerHTML={{ __html: stringUtil.convertNewlineToBr(deltaBody) }}>
                                                </div>
                                            </>
                                            :
                                            <>
                                                <TextInput
                                                    className="form-control mb-4"
                                                    type="text"
                                                    id="checkResultTitle"
                                                    placeholder="수정된 제목이 표시됩니다."
                                                    value={viewDelta === 'N' ? checkResultTitle : deltaTitle}
                                                    readOnly={true}
                                                />
                                                <TextInput
                                                    className="form-control mb-4"
                                                    type="text"
                                                    id="checkResultBody"
                                                    rows={20}
                                                    placeholder="수정된 본문이 표시됩니다."
                                                    value={viewDelta === 'N' ? checkResultBody : deltaBody}
                                                    readOnly={true}
                                                />
                                            </>
                                    }
                                    <div className='modal-footer'>
                                        <SwitchButton
                                            id="viewDelta"
                                            label="변경사항 보기"
                                            checked={viewDelta === "Y"}
                                            onChange={setValue}
                                        />
                                        <SingleButton
                                            className="btn btn-primary"
                                            label="적용하기"
                                            disabled={viewDelta === "Y"}
                                            handleClick={applyGeneratedMessage}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </>
                    }
                </div>
            </Modal>
        )
    }
}

export default MessageAIModal;
